<template>
  <section id="home-laptops-desktop">
    <div class="container">
      <div ref="groupType" class="row sticky">
        <div class="col">
          <div class="group-list">
            <span v-for="type in types"
              :key="type.slug"
              class="group-item"
              :class="{ 'active': active.slug === type.slug }"
              @click="switchType(type)"
              v-scroll-to="{ el: '#group-type-header', offset: -160 }">
              {{ type.title }}
            </span>
          </div>
        </div>
      </div>

      <div id="group-type-header" class="row">
        <div class="col">
          <h2>{{ active.title }}</h2>
          <p>{{ active.description }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="product-list">
            <template v-if="isLoading">
              <CardProduct v-for="item in 5"
                :key="item"
                :small="true" />
            </template>

            <template v-else>
              <CardProduct
                v-for="(product, index) in products"
                :key="index"
                :data="product" />
            </template>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'HomeProductsDesktop',

  data() {
    return {
      isLoading: true,

      active: {
        title: 'All Laptops',
        slug: 'all',
      },

      params: {
        show: 20,
        type_laptop: [],
      },

      products: [],

      types: [
        {
          title: 'All Laptops',
          slug: 'all',
          description: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit',
        },
        {
          title: 'Mainstream',
          slug: 'mainstream',
          description: 'Quasi possimus quia voluptatibus praesentium aperiam.',
        },
        {
          title: 'Premium',
          slug: 'premium',
          description: 'Voluptatem sint cupiditate velit debitis doloribus perferendis.',
        },
        {
          title: 'Gaming',
          slug: 'gaming',
          description: 'Quidem ex eveniet reprehenderit nulla nesciunt illum fugiat corporis.',
        },
      ],
    };
  },

  mounted() {
    this.init();
  },

  methods: {
    async init() {
      this.products = await this.fetchProducts();
      this.isLoading = false;
      this.stickyObserver();
    },

    async switchType(type) {
      try {
        const { slug } = type;
        this.setParams(slug);
        this.active = type;
        this.isLoading = true;
        this.products = [];
        this.products = await this.fetchProducts();
        this.isLoading = false;
      } catch (e) {
        console.error('Failed to fetch products', e);
      }
    },

    setParams(slug) {
      const types = (slug === 'all') ? ['mainstream', 'gaming', 'premium'] : [slug];
      this.params.type_laptop = types;
    },

    fetchProducts() {
      return this.$mainApi.get('products', { params: this.params })
        .then((res) => res.data.data.result.data);
    },

    stickyObserver() {
      if (!this.$refs.groupType) return;
      const options = { threshold: [1] };
      const onIntersecting = ([{ intersectionRatio, target }]) => target.classList.toggle('stuck', intersectionRatio < 1);
      const observer = new IntersectionObserver(onIntersecting, options);
      observer.observe(this.$refs.groupType);
    },
  },
};
</script>

<style lang="scss" scoped>
  #home-laptops-desktop {
    background-color: #f4f4f4;

    h2 {
      font-size: 1.5rem;
      font-weight: normal;
      color: $color-secondary;
    }

    p {
      line-height: 1.75;
      font-size: 0.875rem;
      margin-bottom: 2rem;
    }

    .sticky {
      top: -1px;
      padding-top: calc(1rem + 1px);
      background-color: #f4f4f4;
      z-index: 3;
    }

    .group-list {
      display: flex;
    }

    .group-item {
      min-width: 8rem;
      padding: 2rem 1rem 0.75rem;
      margin: 0 0.5rem 1rem 0;
      border: 1px solid rgba($black, 0.3);
      border-radius: 0.25rem;
      font-size: 0.75rem;
      font-weight: 600;
      color: $grey-dark;
      background-color: $white;
      cursor: pointer;
      transition: all 0.3s ease;

      &:hover {
        border: 1px solid rgba($black, 0.7);
      }

      &.active {
        background-color: $color-primary;
        color: $white;
      }
    }

    .stuck .group-item {
      padding: 0.75rem 1rem 0.75rem;
    }

    .product-list {
      display: flex;
      flex-wrap: wrap;
      margin: 0 -0.5rem;

      .card-product {
        width: calc(20% - 1rem);

        @include media ('<=tablet') {
          width: calc(50% - 1rem);
        }
      }
    }
  }
</style>
